var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{style:(_vm.$route.name === 'AppAgency' ? 'margin-top: 10px;' : '')},[_c('BlogList',{attrs:{"type":"support"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }